module.exports = __webpack_public_path__ + "img/sam_35x45.e7636c7d.jpg";